import { Helmet } from 'react-helmet-async';
import ClinicTelecarePackagesView from 'src/sections/clinic-dashboard/telepackages/telepackages-view';

export default function ClinicTelecarePackagesPage() {
  return (
    <>
      <Helmet>
        <title>Clinic Telecare Packages</title>
      </Helmet>

      <ClinicTelecarePackagesView />
    </>
  );
}
